import { IndustryEditForm } from "./EditIndustries";
import { hasUserPermission } from "../utils/userPermissions";
import CreateRecordModal from '../components/CreateRecordModal';
import PermissionGate from '../components/PermissionGate';
import React, { useState } from "react";
import { Alert, Button } from '@themesberg/react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPlus, faIndustry } from '@fortawesome/free-solid-svg-icons';
import { PageIndustriesTable } from "../components/Tables";
import ListingViewToggle from "../components/ListingViewToggle";
import { IndustryForm } from "./CreateIndustries";

export default () => {
  const [viewMode, setViewMode] = useState("grid");
  const [showCreateModal, setShowCreateModal] = useState(false);
  const [isCreating, setIsCreating] = useState(false);
  const [editingIndustryId, setEditingIndustryId] = useState(null);
  const [isUpdating, setIsUpdating] = useState(false);
  const [refreshKey, setRefreshKey] = useState(0);
  const [successMessage, setSuccessMessage] = useState("");

  const closeCreateModal = () => {
    if (!isCreating) setShowCreateModal(false);
  };

  const handleIndustryCreated = (result) => {
    setShowCreateModal(false);
    setSuccessMessage(result.message || 'Industry created successfully.');
    setRefreshKey(value => value + 1);
  };

  const openEditModal = id => {
    if (!hasUserPermission("industries", "edit")) return;
    setSuccessMessage("");
    setEditingIndustryId(id);
  };

  const closeEditModal = () => {
    if (!isUpdating) setEditingIndustryId(null);
  };

  const handleIndustryUpdated = result => {
    setEditingIndustryId(null);
    setSuccessMessage(result.message || "Industry updated successfully.");
    setRefreshKey(value => value + 1);
  };

  return (
    <div className="listing-page">
      <div className="listing-page__header">
        <div>
          <p className="listing-page__eyebrow mb-1">Configuration</p>
          <h2 className="listing-page__title mb-1">Industries</h2>
          <p className="listing-page__subtitle mb-0">
            Organize industry segments and their sub-categories for quotes and customers.
          </p>
        </div>

        <div className="listing-page__actions">
          <ListingViewToggle viewMode={viewMode} onChange={setViewMode} />
          <PermissionGate module="industries" action="add"><Button
            variant="primary"
            className="btn-quote-blue listing-page__cta"
            onClick={() => { setSuccessMessage(""); setShowCreateModal(true); }}
          >
            <FontAwesomeIcon icon={faPlus} className="me-2" />
            Create Industry
          </Button></PermissionGate>
        </div>
      </div>

      {successMessage && (
        <Alert variant="success" dismissible onClose={() => setSuccessMessage("")}>
          {successMessage}
        </Alert>
      )}

      <PageIndustriesTable viewMode={viewMode} refreshKey={refreshKey} onEditIndustry={openEditModal} />

      <CreateRecordModal
        show={showCreateModal}
        onHide={closeCreateModal}
        isSubmitting={isCreating}
        titleId="create-industry-title"
        title="Create Industry"
        description="Add an industry or organize it under a parent industry."
        icon={faIndustry}
        size="lg"
      >
        {showCreateModal && (
          <IndustryForm
            onSuccess={handleIndustryCreated}
            onCancel={closeCreateModal}
            onSubmittingChange={setIsCreating}
            menuPortalTarget={null}
          />
        )}
      </CreateRecordModal>

      <CreateRecordModal
        show={editingIndustryId !== null}
        onHide={closeEditModal}
        isSubmitting={isUpdating}
        titleId="edit-industry-title"
        title="Edit Industry"
        description="Update industry details and company assignments."
        icon={faIndustry}
        size="lg"
      >
        {editingIndustryId !== null && (
          <IndustryEditForm key={editingIndustryId} industryId={editingIndustryId}
            onSuccess={handleIndustryUpdated} onCancel={closeEditModal} onSubmittingChange={setIsUpdating} />
        )}
      </CreateRecordModal>
    </div>
  );
};
